import { Outlet, useLocation } from 'react-router-dom';
import { useSmoothScroll } from '../../lib/useSmoothScroll';
import U99Nav from './U99Nav';
import U99Footer from './U99Footer';

export default function U99Layout() {
  const scrollTo = useSmoothScroll('/u99');
  const { pathname } = useLocation();
  return (
    <div className="App bg-[#02040a] text-slate-100 min-h-screen" data-testid="u99-root">
      <U99Nav pathname={pathname} />
      <Outlet context={{ scrollTo }} />
      <U99Footer />
    </div>
  );
}
